<template>
  <div>
    <span :class="{'m--margin-right-10': !toggleMore}">
      Zapoznałem(-am) się i akceptuję postanowienia
      <span v-if="isTermsPageSet">
        <a href="#" @click="showTermsModal">Regulaminu</a> oraz
      </span>
      <a href="#" @click="showPrivacyPolicyModal">Polityki Prywatności</a>.
    </span>
    <span v-if="toggleMore">
      Tym samym wyrażam zgodę
    na przetwarzanie przez Administratora moich danych osobowych podanych podczas procesu rejestracji oraz w
    trakcie świadczenia usługi. Zostałem poinformowany, iż tak wyrażoną zgodę mogę w każdej chwili wycofać.
    </span>
    <a @click="toggleMore = !toggleMore" class="bold pointer">{{ toggleMoreText }}</a>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import {PAGE, PRIVACY_POLICY} from "@/utils/PageModalTypes";

  export default {
    name: "RequiredAgreement",
    props: {
      openInModal: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        toggleMore: false
      }
    },
    methods: {
      ...mapActions([
        'setPageModal'
      ]),
      showTermsModal() {
        if (this.openInModal) {
          this.setPageModal({
            show: true,
            type: PAGE,
            title: 'Regulamin',
            content: 'terms/' + this.entityUuid
          });
        } else {
          this.$router.push({name: 'CustomPage', params: {pageUuid: 'terms'}})
        }
      },
      showPrivacyPolicyModal() {
        if (this.openInModal) {
          this.setPageModal({
            show: true,
            type: PRIVACY_POLICY,
            title: 'Polityka prywatności',
            content: ''
          });
        } else {
          this.$router.push({name: 'PrivacyPolicyPage'})
        }
      },
    },
    computed: {
      ...mapState({
        entityUuid: state => state.auth.entity.uuid,
        isTermsPageSet: state => state.settings.termsPageUuid !== null,
        termsPageUuid: state => state.settings.termsPageUuid
      }),
      toggleMoreText() {
        return this.toggleMore
          ? 'Pokaż mniej'
          : 'Pokaż więcej'
      }
    }
  }
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
